import ArrayUtil from '@leverege/array-util';
import Constants from './Constants.js';
/**
 * behavior for the GET action
 * @param {object} state - current redux state
 * @param {object} action - redux action
 */
function receive(state, action) {
  const nState = {
    total: action.total,
    perPage: action.perPage,
    status: Constants.STATUS_DONE,
    statusMessage: null,
    search: action.search,
    items: [].concat(state.items),
    lookup: {
      ...state.lookup
    },
    error: false
  };

  // copy new items into the array
  for (let n = 0, tn = action.startIndex; n < action.items.length; n++, tn++) {
    nState.items[tn] = action.items[n];
    nState.lookup[action.items[n].id] = action.items[n];
  }
  return nState;
}

/** 
 * behavior for the UPDATE action
 * @param {object} state - current redux state
 * @param {object} action - redux action
 */

function update(state, action) {
  const nState = {
    ...state
  };
  nState.items = [].concat(state.items || []);
  nState.lookup = {
    ...state.lookup
  };
  nState.error = false;
  if (action.item != null) {
    ArrayUtil.replace(nState.items, 'id', action.item.id, action.item);
    nState.lookup[action.item.id] = action.item;
  }
  return nState;
}

/**
 * behavior for the ADD action
 * @param {object} state - current redux state
 * @param {object} action - redux action
 */

function add(state, action) {
  const nState = {
    ...state
  };
  nState.lookup = {
    ...state.lookup
  };
  nState.items = [].concat(state.items || []);
  nState.items.push(action.item);
  nState.lookup[action.item.id] = action.item;
  nState.error = false;
  return nState;
}

/**
 * behavior for the REMOVE action
 * @param {object} state - current redux stae
 * @param {object} action - redux action
 */

function remove(state, action) {
  const nState = {
    ...state
  };
  nState.lookup = {
    ...state.lookup
  };
  nState.items = [].concat(state.items || []);
  ArrayUtil.remove(nState.items, 'id', action.itemId || action.item.id);
  delete nState.lookup[action.itemId || action.item.id];
  nState.error = false;
  return nState;
}

/**
 * creates and returns a generic reducer 
 * @param {object} initialState 
 * @param {string} actionTypeBase - determines what constants will be used for the action types
 * @param {*} additionalReducers - function that will be called with state and action in the default case
 */

function reducer(initialState, actionTypeBase, additionalReducers = (state, action) => {
  return state;
}) {
  const dis = {
    error: false,
    search: null,
    perPage: 100,
    total: 0,
    items: [],
    lookup: {}
  };
  initialState = initialState ? {
    ...dis,
    ...initialState
  } : dis;
  const STATUS = Constants[`GET_${actionTypeBase}S_STATUS`];
  const GET = Constants[`GET_${actionTypeBase}S`];
  const GET_ONE = Constants[`GET_${actionTypeBase}`];
  const ADD = Constants[`ADD_${actionTypeBase}`];
  const REMOVE = Constants[`REMOVE_${actionTypeBase}`];
  const UPDATE = Constants[`UPDATE_${actionTypeBase}`];

  // eslint-disable-next-line default-param-last
  return function (state = initialState, action) {
    switch (action.type) {
      case STATUS:
        {
          const nState = {
            ...state
          };
          nState.status = action.status;
          nState.statusMessage = action.statusMessage;
          if (action.status === Constants.STATUS_ERROR) {
            nState.error = true;
          }
          return nState;
        }
      case GET:
        return receive(state, action);
      case GET_ONE:
      case UPDATE:
        return update(state, action);
      case ADD:
        return add(state, action);
      case REMOVE:
        return remove(state, action);
      default:
        return additionalReducers(state, action);
    }
  };
}
export default {
  receive,
  add,
  remove,
  update,
  reducer
};